import { Record } from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
const TagArticlesPanelState = Record({
  searchTerm: null,
  isSaving: false,
  saveError: null
});
const INITIAL_STATE = new TagArticlesPanelState();
export default function tagArticlesPanel(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.TAG_ARTICLES_WITH_TERM:
      return state.merge({
        searchTerm: action.payload.searchTerm
      });
    case ActionTypes.TAG_ARTICLES_WITH_TERM_COMPLETE:
      return state.merge({
        searchTerm: null
      });
    case ActionTypes.APPLY_TAG_TO_ARTICLES_PENDING:
      return state.merge({
        isSaving: true
      });
    case ActionTypes.APPLY_TAG_TO_ARTICLES_SUCCESS:
      return state.merge({
        isSaving: false
      });
    case ActionTypes.APPLY_TAG_TO_ARTICLES_ERROR:
      return state.merge({
        isSaving: false,
        saveError: action.error
      });
    default:
      return state;
  }
}